export default "__VITE_ASSET__9341bbaf__"